/* eslint-disable react/prop-types */
import { Table } from 'antd';
import GenericTableContainer from '~/components/GenericTableContainer';

const MasterTable = ({ cardHeaderTitle, navigateTo, cardButtonText, ...tableParams }) => {
  return (
    <GenericTableContainer
      cardHeaderTitle="Category Master"
      navigateTo="/create/category-master"
      cardButtonText="ADD CATEGORY"
    >
      <Table {...tableParams} />
    </GenericTableContainer>
  );
};

export default MasterTable;
